<template>
  <v-layout class="grey lighten-4" column>
    <v-toolbar dense absolute width="100%">
      <v-toolbar-title>
        Restaurante {{ restaurant.name }}
      </v-toolbar-title>
    </v-toolbar>
    <v-layout wrap>
      <v-flex xs12 md6 style="margin-top: 40px">
        <v-container>
          <areas-list />
        </v-container>
      </v-flex>
      <v-flex xs12 md6 style="margin-top: 40px">
        <v-container>
          <sections-list />
        </v-container>
      </v-flex>
    </v-layout>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-layout>
</template>

<script>
import AreasList from './areas/List'
import SectionsList from './sections/List'

export default {
  name: 'RestaurantDetails',
  components: {
    AreasList,
    SectionsList
  },
  data () {
    return {
      section: 'Details',
      overlay: false,
      restaurant: {}
    }
  },
  watch: {
    '$store.state.restaurant': function (val) {
      if (val.uuid) {
        this.$router.push({ name: 'RestaurantDetails', params: { id: val.uuid } })
      }
    },
    async $route (val) {
      await this.load()
    }
  },
  mounted: async function () {
    await this.load()
  },
  methods: {
    async load () {
      const { id } = this.$route.params
      this.overlay = true
      try {
        const response = await this.$api.get(`/v1/restaurants/${id}`)
        this.restaurant = response
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    back () {
      const { page, items } = this.$route.params
      this.$router.push({
        name: 'Restaurants',
        params: {
          page,
          items
        }
      })
    }
  }
}
</script>
